import styled from 'styled-components';

export const FormTitle = styled.h3`
  margin: 0;
  text-align: center;
`;

export const InputIcon = styled.img`
  height: auto;
  width: 24px;
`;

export const EmailIcon = styled(InputIcon)`
  position: absolute;
  width: 18px;
  left: 16px;
`;

export const QuestionIcon = styled(InputIcon)`
  width: 22px;
  cursor: pointer;
`;

export const CloseIcon = styled(QuestionIcon)`
  width: 14px;
  align-self: flex-end;
`;

export const BenefitFormTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: 'center';
`;

export const BenefitFormContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  height: 500px;
  margin-top: 10px;
  padding: 0px 20px 20px 20px;
`;

export const BenefitVersionFormContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px;
`;

export const FormItem = styled.div`
  flex: 0 0 calc(33.33% - 20px); /* 33.33% width with a little spacing */
`;

export const SubmitContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

export const StyledErrorWrap = styled.p`
  height: 12px;
  font-size: 14px;
  margin: 5 0 0 0;
  color: red;
`;
